<template>
  <div class="grid md:grid-cols-2 gap-7 pt-8 md:pt-0 h-screen px-8">
    <div class="flex flex-col content-center justify-center h-full lg:max-w-lg pt-10 md:pt-0">
      <div class="max-w-xl text-center md:text-left mb-6">
        <h2 class="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
          <span class="bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-pink-500 to-purple-500">Wellcome</span> To Our Page
        </h2>
        <p class="text-base text-gray-700 md:text-lg">
          We are android developer. we built the app as a Free app. This service is provided by <b class="italic">pustaka digital</b> at no cost and is intended for use as is.
        </p>
      </div>
      <div class="text-center md:text-left">
        <a href="https://play.google.com/store/apps/dev?id=8797303309855216390" target="_blank" class="inline-flex hover:text-gray-400 text-indigo-400 items-center font-semibold transition-colors duration-200 text-deep-purple-accent-400 hover:text-deep-purple-800">Visit Store
          <svg class="inline-block w-3 ml-2" fill="currentColor" viewBox="0 0 12 12">
            <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z"></path>
          </svg>
        </a>
      </div>
    </div>
    <div class="flex flex-col content-start md:content-center md:justify-center md:h-full ">
      <div class="flex flex-wrap">
        <template v-if="project">
          <div v-for="{ id, icon, name } in project" :key="id" class="my-2 px-2 w-1/3 md:w-1/4 lg:w-1/6">
            <router-link :to="{ name: 'Project', params: { id: id }}">
              <div class="relative  h-auto w-full overflow-hidden transition duration-200 transform rounded-lg shadow-lg hover:-translate-y-2 hover:shadow-2xl">
                <img class="object-cover w-full h-auto" :src="icon" alt="" />
                <div class="absolute text-center  inset-0 px-2 py-2 transition-opacity duration-200 bg-indigo-500 bg-opacity-75 opacity-0 hover:opacity-100">
                  <p class="mb-4 font-semibold text-gray-100">{{ name }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </template>
        <template v-else-if="state === STATE.loading">
           <span class="inline items-center justify-center inline-flex w-full">
              <svg class="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="animate-pulse text-lg font-bold ml-2">Loading...</span>
            </span>
        </template>
        <template v-else-if="state === STATE.error">
          {{ error }} error
        </template>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {projectList} from "@/firebase";
import {useSwrCache, STATE} from "@/composables/swr-cache";

export default {
  name: 'Home',
  setup() {
    const {
      data: project,
      error,
      state,
    } = useSwrCache('userList', projectList);

    return {
      STATE,
      error,
      state,
      project,
    };
  },
}
</script>
